// extracted by mini-css-extract-plugin
export default {"container":"Books_container__l2LZN","page":"Books_page__ny43q","addChapterButton":"Books_addChapterButton__s-mW3","lessons":"Books_lessons__rK6Kn","popup":"Books_popup__oYH4M"};